import { render } from "./OsCards.vue?vue&type=template&id=c996251e"
import script from "./OsCards.vue?vue&type=script&lang=js"
export * from "./OsCards.vue?vue&type=script&lang=js"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__